import { Config } from '../../config'

export const csiConfig: Config = {
  partner: 'csi',
  catalog: 'partner',
  displayName: 'Canadian Scientific',
  accentColor: '#a8872f',
  host: 'seating.canadianscientific.ca',
  extraAttributes: {
  }
}
